import BasicService from "./BasicService";

class TaskService extends BasicService {
  constructor() {
    super();
  }
  getTaskList(
    type,
    fromDate,
    toDate,
    userAccountId,
    osId,
    fromBranch,
    toBranch,
    dateChange
  ) {
    let url = "/excels/task";
    return this.axios.get(url, {
      params: {
        type,
        fromDate,
        toDate,
        userAccountId,
        osId,
        fromBranch,
        toBranch,
        dateChange
      }
    }).then(request => request.data);
  }
  getDailyList(
    type,
    userAccountId,
    osId
  ) {
    let url = "/excels/daily";
    return this.axios.get(url, {
      params: {
        type,
        userAccountId,
        osId
      }
    }).then(request => request.data);
  }
  dailyListDownload(
    type,
    userAccountId,
    osId) {
    return this.axios({
      url: "/excels/deliverys/daily",
      method: "GET",
      responseType: "blob",
      params: {
        type,
        userAccountId,
        osId
      } // important
    });
  }
  searchOrderOs(fromDate,toDate,type,osId) {
    let url = `/excels/orderos`
    return this.axios.get(url,
      {
        params: {
          type,
          fromDate,
          toDate,
          osId
        }
      }).then(request => request.data);
  }
  searchOsNoti(fromDate,toDate,osId,deliId,status) {
    let url = `/os/noti`
    return this.axios.get(url,
      {
        params: {
          fromDate,
          toDate,
          osId,
          deliId,
          status
        }
      }).then(request => request.data);
  }
  searchPickup(pickupDate) {
    let url = `/os/noti/pickup`
    return this.axios.get(url,
      {
        params: {
          pickupDate
        }
      }).then(request => request.data);
  }
  saveOsNoti(osNoti) {
    let url = `/os/noti`
    return this.axios.post(url,osNoti).then(request => request.data);
  }
  updateOsNoti(osNoti) {
    let url = `/os/noti/${osNoti.notiId}`
    return this.axios.put(url,osNoti).then(request => request.data);
  }
  deleteOsNoti(osNoti) {
    let url = `/os/noti/${osNoti.notiId}`
    return this.axios.delete(url).then(request => request.data);
  }
  updateOsNotiMsg(osNoti) {
    let url = `/os/noti/${osNoti.notiId}/msg`
    return this.axios.put(url,osNoti).then(request => request.data);
  }
  taskStatus(itemIdList) {
    let url = `orders/task/status`
    return this.axios.post(url,itemIdList).then(request => request.data);
  }
}

const taskService = new TaskService();
export default taskService;
